import * as Yup  from 'yup';
import { rules } from '../shared/rules';

export const resetPasswordFormSchema = Yup.object().shape({
  password        : rules.password,
  confirmPassword : Yup.string()
    .required('Confirm your password')
    .oneOf([ Yup.ref('password'), null ], 'Passwords must match'),
}, [ [ 'password', 'confirmPassword' ] ]);
